var localeData = require('../es.json')
exports = module.exports = localeData
exports['default'] = localeData